import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-294b888d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["aria-invalid", "aria-labelledby"]
const _hoisted_5 = ["checked", "id", "name", "onChange", "value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = ["data-src"]
const _hoisted_8 = { class: "category-question__variant-text" }

import { InterviewQuestionResponseModel, Variant } from '@/models/QuestionModels'
import { useInterviewStore } from '@/stores/interviewStore'
import FlatButton from '@/components/Shared/FlatButton.vue'
import { computed, onMounted, ref } from 'vue'
import { QuestionType } from '@/models/QuestionType';
import { scrollToElementBottom } from '../scrollToElementBottom';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButtonThemeQuestion',
  props: {
    question: null,
    isStandAlone: { type: Boolean, default: true }
  },
  emits: ['handleAnswerChoose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { question: InterviewQuestionResponseModel, isStandAlone: boolean };

const interviewStore = useInterviewStore()

const answer = ref<Variant | undefined>(undefined);
const isSubmited = ref<boolean>(false)

const root = ref<HTMLElement | undefined>(undefined);
onMounted(() => scrollToElementBottom(root!.value as HTMLElement));



// categoryQuestion
const isCategory = props.question.Type === QuestionType.CategoryQuestion;



const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const isSubmitable = computed(() => !!answer.value?.Value)

if (interviewStore.currentQuestion?.value && isCategory) {
    const preselectedVariant = interviewStore.currentQuestion.key
        .Variants?.find((v) => `${ v.CategoryId }:${ v.Label }` === interviewStore.currentQuestion?.value);
    
    if (preselectedVariant) {
        isSubmited.value = true;
    }
}

function onAnswerChoose(btn: Variant) {
    // category question dont have value????
    const value = btn.Value || btn.Label

    if (!(value && props.question.Id)) {
        return;
    }

    answer.value = btn
    answer.value.Value = value

    if (answer.value.Script?.length) {
        interviewStore.replaceVariants(props.question, answer.value)
        interviewStore.resetCategoryIndex(props.question)

        if (isSubmited.value) {
            interviewStore.nextQuestion();
        }
    }

    emits('handleAnswerChoose', btn)

    submitQuestion();
}

function submitQuestion() {
    if (!isSubmitable.value || (interviewStore.isLastQuestion && interviewStore.checkError())) {
        return;
    }

    const value = isCategory ?
        interviewStore.getCategoryAnswer(answer.value) : `${answer.value?.Value!}`;

    interviewStore.changeAnswer(props.question.Id, value);

    if (!isSubmited.value) {
        interviewStore.nextQuestion();
    }

    isSubmited.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question category-question"
  }, [
    _createElementVNode("div", {
      id: __props.question.Id + '_label',
      class: "tw-question__title"
    }, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ], 8, _hoisted_1),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: __props.question.Description,
          class: "tw-question__description"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "category-question__group",
      "aria-required": true,
      "aria-invalid": !_unref(isSubmitable),
      role: "radiogroup",
      "aria-labelledby": __props.question.Id + '_label'
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.Variants, (btn, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["category-question__variant-item", { 'category-question__variant-item--selected': btn.Label === answer.value?.Label }]),
          key: `${__props.question.Id}_${index}`
        }, [
          _createElementVNode("input", {
            class: "category-question__input",
            type: "radio",
            checked: btn.Label === answer.value?.Label,
            id: btn.Label,
            name: __props.question.Id+'radio',
            onChange: ($event: any) => (onAnswerChoose(btn)),
            value: btn
          }, null, 40, _hoisted_5),
          _createElementVNode("label", {
            for: btn.Label,
            class: "category-question__variant-label"
          }, [
            (btn.Image)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  class: "category-question__variant-image",
                  style: _normalizeStyle(`--activeColor: ${ isCategory ? __props.question.ColorImage : btn.ColorImage }`),
                  "data-src": btn.Image,
                  alt: ""
                }, null, 12, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString(btn.Label), 1)
          ], 8, _hoisted_6)
        ], 2))
      }), 128))
    ], 8, _hoisted_4),
    (__props.isStandAlone && _unref(isSubmitable) && !isSubmited.value)
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 1,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})